export { default } from "./ExtensionTab.jsx";
